const DELAY = 50; // delay to allow view side panel to change before scrolling to the requested position
const DELAY_MOUNT = 500; // delay to allow a conditionally rendered panel to mount before scrolling

export function scrollQuizPanelToTop() {
  setTimeout(() => {
    window.location.href = `#panel-top`;
  }, DELAY);
}

export function scrollQuizPanelToId(id: string) {
  setTimeout(() => {
    window.location.href = id;
  }, DELAY);
}

export function scrollQuizPanelToIdSmooth(id: string) {
  setTimeout(() => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, DELAY_MOUNT);
}
